import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  label?: string;
  options: SelectOption[];
  error?: string;
  onChange?: (value: string) => void;
}
export function Select({
  label,
  options,
  error,
  onChange,
  className = '',
  id,
  value,
  ...props
}: SelectProps) {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-815">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-816">
          {label}
        </label>}
      <div className="relative" data-id="element-817">
        <select id={selectId} value={value} onChange={e => onChange?.(e.target.value)} className={`
            w-full px-4 py-2.5 pr-10 rounded-lg border appearance-none cursor-pointer
            transition-all duration-200
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200' : 'border-gray-300 focus:border-primary-500 focus:ring-2 focus:ring-primary-200'}
            disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
            ${className}
          `} aria-invalid={error ? 'true' : 'false'} {...props} data-id="element-818">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-819">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" data-id="element-820" />
      </div>
      {error && <p className="mt-1.5 text-sm text-red-600" role="alert" data-id="element-821">
          {error}
        </p>}
    </div>;
}